import { axiosInstance as CloudApiInstance } from "../../APIS";

// Services

export const fetchAllServices = async (params) => {
  const response = await CloudApiInstance.get(`/services`, { params });
  return response?.data;
}

export const createService = async (serviceData) => {
  const response = await CloudApiInstance.post(`/services`, serviceData);
  return response?.data;
}

export const updateService = async (serviceId, serviceData) => {
  const response = await CloudApiInstance.put(`/services/${serviceId}`, serviceData);
  return response?.data;
}

export const deleteService = async (serviceId) => {
  const response = await CloudApiInstance.delete(`/services/${serviceId}`);
  return response?.data;
}

export const fetchEticketingBookings = async (params) => {
  const response = await CloudApiInstance.get(`/booking`, { params });
  return response?.data;
}

export const createEticketingBooking = async (bookingData) => {
  const response = await CloudApiInstance.post(`/booking`, bookingData);
  return response?.data;
}

export const fetchEticketingTickets = async (params) => {
  const response = await CloudApiInstance.get(`/ticket/${params.bookingId}`);
  return response?.data;
}

export const fetchAllRoutes = async (params) => {
  const response = await CloudApiInstance.get(`/routes`, { params });
  return response?.data;
}

export const fetchAllPrices = async (params) => {
  const response = await CloudApiInstance.get(`/prices`, { params });
  return response?.data;
}

export const fetchEticketingTimings = async (params) => {
  const response = await CloudApiInstance.get(`/timings`, { params });
  return response?.data;
}

export const createEticketingTiming = async (timingData) => {
  const response = await CloudApiInstance.post(`/timings`, timingData);
  return response?.data;
}

export const updateEticketingTiming = async (timingId, timingData) => {
  const response = await CloudApiInstance.put(`/timings/${timingId}`, timingData);
  return response?.data;
}

export const deleteEticketingTiming = async (timingId) => {
  const response = await CloudApiInstance.delete(`/timings/${timingId}`);
  return response?.data;
}

export const fetchEticketingContents = async (params) => {
  const response = await CloudApiInstance.get(`/content`, { params });
  return response?.data;
}

export const createEticketingContent = async (contentData) => {
  const response = await CloudApiInstance.post(`/content`, contentData);
  return response?.data;
}

export const updateEticketingContent = async (contentId, contentData) => {
  const response = await CloudApiInstance.put(`/content/${contentId}`, contentData);
  return response?.data;
}

export const fetchAllBuses = async (params) => {
  const response = await CloudApiInstance.get(`/buses`, { params });
  return response?.data;
}

export const fetchBus = async (busId) => {
  const response = await CloudApiInstance.get(`/buses/${busId}`);
  return response?.data;
}

export const createBus = async (busData) => {
  const response = await CloudApiInstance.post(`/buses`, busData);
  return response?.data;
}

export const deleteBus = async (busId) => {
  const response = await CloudApiInstance.delete(`/buses/${busId}`);
  return response?.data;
}

export const updateBus = async (busId, busData) => {
  const response = await CloudApiInstance.put(`/buses/${busId}`, busData);
  return response?.data;
}

export const createRoutePrice = async (priceData) => {
  const response = await CloudApiInstance.post(`/prices`, priceData);
  return response?.data;
}

export const updateRoutePrice = async (priceId, priceData) => {
  const response = await CloudApiInstance.put(`/prices/${priceId}`, priceData);
  return response?.data;
}

export const getRoutePrices = async (routeId) => {
  const response = await CloudApiInstance.get(`/routes/${routeId}/prices`);
  return response?.data;
}

export const deleteRoutePrice = async (priceId) => {
  const response = await CloudApiInstance.delete(`/prices/${priceId}`);
  return response?.data;
}

export const fetchAllCities = async (params) => {
  const response = await CloudApiInstance.get(`/cities`, { params });
  return response?.data;
}

export const fetchDashboardStats = async (params) => {
  const response = await CloudApiInstance.get(`/dashboard/stats`, { params });
  return response?.data;
}

export const fetchDashboardFilters = async (params) => {
  const response = await CloudApiInstance.get(`/dashboard/filters`, { params });
  return response?.data;
}

export const fetchAllUsersRoles = async () => {
  const response = await CloudApiInstance.get(`/users/roles/all`);
  return response?.data;
}